import moment from "moment";

const isGeneratedForecast = (d) => {
  if (d === undefined) return false;
  const date = moment(`${d?.year}${d?.month}`, "YYYYMM");
  return date > moment().add(3, "months");
};

export default isGeneratedForecast;
